import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Pictogram } from '@sola/ark-core/atoms/pictogram/pictogram.tsx';
import { knownDotcomUrls } from '@sola/my-sdk/constants.ts';
import type { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
import { usePrimaryCtaChristmas } from './primary-cta-christmas.logic.ts';
const defaultCommitments: GraphQLCommitment[] = [];
export const PrimaryCtaChristmas: React.FC<{
  sponsorships: GraphQLCommitment[];
}> = t0 => {
  const $ = _c(17);
  const {
    sponsorships: t1
  } = t0;
  const sponsorships = t1 === undefined ? defaultCommitments : t1;
  let t2;
  if ($[0] !== sponsorships) {
    t2 = {
      sponsorships
    };
    $[0] = sponsorships;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t,
    title,
    subtitle
  } = usePrimaryCtaChristmas(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PrimaryCtaIcon><Pictogram name="christmas" /></PrimaryCtaIcon>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== subtitle) {
    t5 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[5] = subtitle;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <PrimaryCtaBody>{t4}{t5}</PrimaryCtaBody>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t("my:primaryCtaChristmas.cta");
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t7) {
    t8 = <PrimaryCtaActions><ButtonStyle variant="secondary"><a href={knownDotcomUrls.christmasGift}>{t7}</a></ButtonStyle></PrimaryCtaActions>;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t8) {
    t9 = <PrimaryCta variant="default">{t3}{t6}{t8}</PrimaryCta>;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};